import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Tabs from './components/tab'
import Pane from './components/pane'

class TabContainer extends Component {
  static propTypes = {
    selected: PropTypes.number.isRequired,
    panes: PropTypes.array.isRequired,
  }

  _renderPanes = () => {
    const panes = this.props.panes

    return panes.map(pane => <Pane key={pane.label} {...pane} />)
  }

  render() {
    return (
      <Tabs selected={this.props.selected} panes={this.props.panes}>
        {this._renderPanes()}
      </Tabs>
    )
  }
}

export default TabContainer
